// @flow

const DIAGRAM_WIDTH = 1100;

// Returns the width of a segment between two vertical lines
export const getSegmentWidth = (nodes: Array<any>): number => {
  const actorNodes = nodes.filter((n) => n.type === 'sequenceActor');
  if (!actorNodes.length) {
    return 0;
  }
  return DIAGRAM_WIDTH / actorNodes.length;
};
